function ProfileCard(props) {
  const React = oxziongui.React;
  const Popup = oxziongui.KendoReactPopup.Popup;

  const [offset, setOffset] = React.useState({
    left: props.event?.clientX,
    top: props.event?.clientY,
  });
  const [profileInfo, setProfileInfo] = React.useState(undefined);

  const fetchProfileInfo = async (identifier) =>
    props.core.make("oxzion/restClient").request("v1", `/user/${identifier}/detail`, {}, "get")

  React.useEffect(() => {
    if (props.identifier) {
      fetchProfileInfo(props.identifier).then((response) => {
        if (response.status === "success") {
          response.data.otherInfo = [
            { icon: "fa-solid fa-envelope", value: response.data.email },
            { icon: "fa-solid fa-users", value: response.data.manager_name },
            { icon: "fa-solid fa-globe", value: response.data.country },
          ];
          setProfileInfo(response.data);
        } else {
          handleClose();
        }
      });
    }
    if (props.offset) {
      setOffset(props.offset);
    }
  }, [props.identifier, props.offset]);

  const handleClose = () => {
    setProfileInfo(undefined);
  };

  return (
    profileInfo && (
      <>
        <div className="popup-background-overlay" style={{ display: "block" }} onClick={handleClose}>
        </div>
        <Popup
          show={true}
          offset={offset}
          animate={false}
          className="profile-info-popup"
          appendTo={document.querySelector(".osjs-profile-info-popup")}
        >
          <div className="profile-info">
            <div className="close-icon" onClick={handleClose}>
              <i className="fa-solid fa-xmark"></i>
            </div>
            <div className="profile-img-container">
              {profileInfo?.icon && profileInfo?.icon !== "" ? (
                <img src={profileInfo.icon} alt="Profile Image" className="profile-img" />
              ) : (
                <div className="profile-icon">
                  <i className="fa-solid fa-user icon"></i>
                </div>
              )}
            </div>
            <div className="profile-content">
              <div className="name text-overflow" title={profileInfo?.name}>{profileInfo?.name}</div>
              <div className="designation text-overflow" title={profileInfo?.designation}>{profileInfo?.designation}</div>
              <div className="chat-mail-link">
                <div className="link-container">
                  <a
                    style={{ textDecoration: "none" }}
                    href={`${process.env.SERVER}${process.env.TEAM}/messages/@${profileInfo?.username}`}
                    target="_blank"
                    className="fa-solid fa-messages"
                  ></a>
                </div>
                <div className="link-container">
                  <a style={{ textDecoration: "none" }} href={`mailto:${profileInfo?.email}`} target="_blank" className="fa-solid fa-envelope"></a>
                </div>
              </div>
              {profileInfo?.otherInfo?.map((item, index) => {
                return (
                  item.value && (
                    <div className="other-info text-overflow" key={index} title={item.value}>
                      <i className={item.icon}></i>
                      {item.value}
                    </div>
                  )
                );
              })}
            </div>
          </div>
        </Popup>
      </>
    )
  );
}

export default ProfileCard;
